import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import locale from '@/utils/en'
// import './permission'
// import 'amfe-flexible'
import './icons'
// import Vant from 'vant'
import 'vant/lib/index.css'
import 'ant-design-vue/dist/antd.css'
import './utils/vConsole'
import Antd from 'ant-design-vue'
// Vue.use(Vant)
Vue.use(Antd) 
Vue.use(ElementUI,{
  locale:locale
}) 
// Vue.use(ELEMENT, { locale })
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
